module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'expandable-drawer': true,
      expanded: _vm.expanded,
    }
  }, [_c('p', {
    staticClass: "title",
    on: {
      "click": function($event) {
        _vm.expanded = !_vm.expanded
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.caret) + " " + _vm._s(_vm.title) + "\n  ")]), _vm._v(" "), (_vm.expanded) ? _c('p', [_vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5252b93a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExpandableDrawer.vue
// module id = 750
// module chunks = 2